import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const BlogWizard = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 151 64"
        data-fill-none
      >
        <rect
          width="151"
          height="64"
          rx="5"
          fill="#F6F1EB"
        />
        <path
          d="M50.6001 69V12.5846C50.6001 11.6339 50.9583 10.7221 51.5959 10.0499C52.2336 9.37766 53.0984 9 54.0001 9H98.2001C99.1018 9 99.9666 9.37766 100.604 10.0499C101.242 10.7221 101.6 11.6339 101.6 12.5846V69"
          fill="white"
        />
        <path
          d="M50.6001 69V12.5846C50.6001 11.6339 50.9583 10.7221 51.5959 10.0499C52.2336 9.37766 53.0984 9 54.0001 9H98.2001C99.1018 9 99.9666 9.37766 100.604 10.0499C101.242 10.7221 101.6 11.6339 101.6 12.5846V69"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.9122 26.2266H59.7236C59.2692 26.2266 58.8334 26.4131 58.5121 26.7451C58.1908 27.0771 58.0103 27.5275 58.0103 27.997V38.6197C58.0103 39.0892 58.1908 39.5395 58.5121 39.8716C58.8334 40.2036 59.2692 40.3901 59.7236 40.3901H93.9122C94.3666 40.3901 94.8024 40.2036 95.1237 39.8716C95.445 39.5395 95.6256 39.0892 95.6256 38.6197V27.997C95.6256 27.5275 95.445 27.0771 95.1237 26.7451C94.8024 26.4131 94.3666 26.2266 93.9122 26.2266Z"
          fill="#FFEDBF"
        />
        <path
          d="M93.8409 26.2246H59.6523C59.1979 26.2246 58.7621 26.4111 58.4408 26.7432C58.1195 27.0752 57.939 27.5255 57.939 27.9951V38.6177C57.939 39.0873 58.1195 39.5376 58.4408 39.8696C58.7621 40.2016 59.1979 40.3882 59.6523 40.3882H93.8409C94.2953 40.3882 94.7311 40.2016 95.0524 39.8696C95.3738 39.5376 95.5543 39.0873 95.5543 38.6177V27.9951C95.5543 27.5255 95.3738 27.0752 95.0524 26.7432C94.7311 26.4111 94.2953 26.2246 93.8409 26.2246Z"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.4631 51.7734H95.5056"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.4631 63.5879H83.0975"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.7539 19.9375H78.1089"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.4631 58.2734H95.5056"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
